import { DateNavigatorComponent } from "./date-navigator/date-navigator.component";
import { PipesModule } from "./../pipes/pipes.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SelectComponent } from "./select/select.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { DiretivasModule } from "../diretivas/diretivas.module";
import { SelectIconContainerComponent } from "../components/select-icon-container/select-icon-container.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { ButtonComponent } from "./button/button.component";
import { Select } from "primeng/select";
import { Checkbox } from "primeng/checkbox";
import { DatePicker } from "primeng/datepicker";
import { DateComponent } from "./date/date.component";
import { InputCepComponent } from "./input-cep/input-cep.component";
import { InputMaskModule } from "primeng/inputmask";
import { InputSearchComponent } from "./input-search/input-search.component";
import { TextAreaComponent } from "./text-area/text-area.component";
import { ToggleButtonComponent } from "./toggle-button/toggle-button.component";
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
    declarations: [
        SelectIconContainerComponent,
        SelectComponent,
        DateNavigatorComponent,
        ButtonComponent,
        CheckboxComponent,
        DateComponent,
        InputCepComponent,
        InputSearchComponent,
        TextAreaComponent,
        ToggleButtonComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DiretivasModule,
        PipesModule,
        Select,
        DatePicker,
        Checkbox,
        InputMaskModule,
        ToggleButtonModule,
        ToggleSwitchModule
    ],
    exports: [
        SelectIconContainerComponent,
        SelectComponent,
        DateNavigatorComponent,
        ButtonComponent,
        CheckboxComponent,
        DateComponent,
        InputCepComponent,
        InputSearchComponent,
        TextAreaComponent,
        ToggleButtonComponent
    ],
})
export class ComponentsModule {}
